import { useEffect, useRef, useState } from 'react';
import { PageControlDot, PageControlDotSelected } from '@sas/react-svg';
import { useRefArray } from '../../../hooks/useRefArray';
import { useIsRTL } from '../../../locale';
import { createUseTextLocalizer } from '../../../locale/createUseTextLocalizer';
import { useDesignTokens } from '../../../theme';
import { Icon } from '../../Icon';
import { Flow } from '../../Layouts/Flow';
import bundle from '../NovaComponents-TileCarousel-gui-icu.properties';
import cn from './PageIndicator.css.json';
import './PageIndicator.css';
import { jsx as _jsx } from "react/jsx-runtime";
const useTextLocalizer = createUseTextLocalizer(bundle);
export const PageIndicator = props => {
  const localize = useTextLocalizer();
  const dt = useDesignTokens();
  const isRTL = useIsRTL();
  const [focusedIndex, setFocusedIndex] = useState(0);
  const containerRef = useRef(null);
  const {
    refs: pageIndicatorDotRefs,
    createSetRef: createPageIndicatorDotRef
  } = useRefArray();
  const handleKeyDown = event => {
    if (event.defaultPrevented) return;
    switch (event.key) {
      case 'ArrowDown': /* falls-through */
      case isRTL ? 'ArrowLeft' : 'ArrowRight':
        setFocusedIndex(prevIndex => Math.min(props.totalPages - 1, prevIndex + 1));
        break;
      case 'ArrowUp': /* falls-through */
      case isRTL ? 'ArrowRight' : 'ArrowLeft':
        setFocusedIndex(prevIndex => Math.max(0, prevIndex - 1));
        break;
      case 'Home':
        setFocusedIndex(0);
        break;
      case 'End':
        setFocusedIndex(props.totalPages - 1);
        break;
      default:
        return;
    }
    event.preventDefault();
  };
  useEffect(() => {
    // Focus on the dot if it does not already have focus and one of the dots has the focus
    if (!pageIndicatorDotRefs[focusedIndex]?.contains(document.activeElement) && containerRef.current?.contains(document.activeElement)) {
      pageIndicatorDotRefs[focusedIndex]?.focus();
    }
  }, [focusedIndex, pageIndicatorDotRefs]);
  return /*#__PURE__*/_jsx(Flow, {
    className: cn.pageIndicator,
    "aria-label": localize('pageIndicator.aria'),
    spacing: "xs",
    role: "radiogroup",
    onKeyDown: handleKeyDown,
    ref: containerRef,
    children: [...Array(props.totalPages)].map((_, index) => {
      const selected = index === props.currentPageIndex;
      const tooltip = props.tooltip?.(index) ?? localize('pageIndicator.dot.aria', {
        number: (index + 1).toString()
      });
      return /*#__PURE__*/_jsx("div", {
        role: "radio",
        tabIndex: -1,
        ref: createPageIndicatorDotRef(index),
        className: cn.pageIndicatorDot,
        title: tooltip,
        "aria-label": props.ariaLabel?.(index) ?? tooltip,
        "aria-checked": selected,
        onFocus: () => {
          setFocusedIndex(index);
        },
        onClick: () => {
          props.onPageTo(index);
        },
        onKeyDown: e => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            props.onPageTo(index);
          }
        },
        children: /*#__PURE__*/_jsx(Icon, {
          icon: selected ? PageControlDotSelected : PageControlDot,
          tokens: () => ({
            'default-fg': selected ? dt.tokens['color-secondary'] : dt.tokens['color-body-text']
          }),
          ariaHidden: true
        })
      }, index);
    })
  });
};
//# sourceMappingURL=PageIndicator.js.map